export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_NOTIFICATIONS_TYPES = 'SET_NOTIFICATIONS_TYPES';
export const MARK_AS_READED_NOTIFICATION = 'MARK_AS_READED_NOTIFICATION';
